import { Link } from "react-router-dom";

import useConfig from "@/hooks/useConfig";
import PageRoutes from "@/utils/constants";

/**
 * Copyright + Privacy Policy / Terms & Conditions card shown at the bottom
 * of a sidebar (currently the Schedule/On Demand filter rail). Legal links
 * open in a new tab so they don't lose the surrounding page's filter state.
 */
export function SidebarLegalFooter() {
  const configData = useConfig();
  const currentYear = new Date().getFullYear();

  return (
    <div className="mt-4 bg-slate-100 rounded-lg text-center py-3 px-3">
      <div className="text-[12px] font-semibold text-slate-700">
        {`© ${currentYear} ${configData?.subtitle ?? ""}`}
      </div>
      <div className="mt-1 text-[11px] text-slate-500">
        <Link
          to={PageRoutes.PrivacyPolicy}
          target="_blank"
          rel="noreferrer"
          className="text-slate-500 hover:underline"
        >
          Privacy Policy
        </Link>
        {" | "}
        <Link
          to={PageRoutes.TermAndConditions}
          target="_blank"
          rel="noreferrer"
          className="text-slate-500 hover:underline"
        >
          Terms & Conditions
        </Link>
      </div>
    </div>
  );
}
